// extracted by mini-css-extract-plugin
module.exports = {"card":"_3pVbw _2s-6N","header":"_4ZK0D","title":"_1eXKQ","icon":"_1iHGb","body":"_38oUt","bodyInline":"_32nZR","info":"_31L5n","chartBipolar":"_1mxP-"};